export default "__VITE_ASSET__3734c507__"